import React from 'react';

import Button from 'components/Button';
import './styles.css';

const Buttons = ({triggerSubmit, submitting, onClose}) => (
  <div className="Buttons">
    <Button onClick={onClose} transparent white className="cancel">
      Cancel
    </Button>
    <Button
      onClick={triggerSubmit}
      className="submit"
      blue={!submitting}
      isLoading={submitting}
      disabled={submitting}>
      Create
    </Button>
  </div>
);

export default Buttons;
